import { documentToHtmlString, type Options } from '@contentful/rich-text-html-renderer'
import type { Document } from '@contentful/rich-text-types'

export const useRichText = (document: Document | null | undefined, options?: Options) => {
  return document ? documentToHtmlString(document, options) : ''
}
